/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Pricing_Enterprise_DescInputs */

const en_landing_pricing_enterprise_desc = /** @type {(inputs: Landing_Pricing_Enterprise_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For large organizations`)
};

const zh_landing_pricing_enterprise_desc = /** @type {(inputs: Landing_Pricing_Enterprise_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`适合大型组织`)
};

/**
* | output |
* | --- |
* | "For large organizations" |
*
* @param {Landing_Pricing_Enterprise_DescInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_pricing_enterprise_desc = /** @type {((inputs?: Landing_Pricing_Enterprise_DescInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Pricing_Enterprise_DescInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_pricing_enterprise_desc(inputs)
	return zh_landing_pricing_enterprise_desc(inputs)
});
export { landing_pricing_enterprise_desc as "landing.pricing.enterprise_desc" }